module.exports = __webpack_public_path__ + "img/cases-brand-yanghe-lazyload-25.58671f44.jpg";